import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Line-by-line masked reveal: each line wrapped in overflow-hidden,
// child animates from y:110% -> 0.
export function MaskedText({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12, as = "h1" }) {
  const MotionTag = motion[as] || motion.h1;
  return (
    <MotionTag className={className} initial="hidden" animate="visible">
      <span className="sr-only">{lines.join(" ")}</span>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            variants={{
              hidden: { y: "115%" },
              visible: { y: "0%" },
            }}
            transition={{ duration: 1.05, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}

// Scroll-triggered reveal (fade + rise).
export function Reveal({ children, className = "", delay = 0, y = 42, once = true, amount = 0.25 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 0.95, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

// Inline word/character overline reveal.
export function FadeIn({ children, className = "", delay = 0 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 1.1, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
